<template>
  <el-card shadow="always" :body-style="{ padding: '20px', height: '72vh' }">
    <div slot="header">
      <div class="flex" style="justify-content: space-between;">
        <div>
          <img src="@/assets/home/new.png" alt="" />
          <span class="hardtext">装配式构件数量</span>
        </div>
        <div>
          <el-button type="primary" @click="workList.push({})"
            >添加</el-button
          >
          <el-button type="success" @click="AddOrUpdate(3)"
            >保存</el-button
          >
        </div>
      </div>
    </div>
    <!-- card body -->
    <div>
      <el-table
        stripe
        :header-cell-style="{
          background: '#EBEFF2',
          color: '#1E2134',
          fontWeight: 'bold',
        }"
        align="center"
        :data="workList"
      >
        <el-table-column align="center" type="index" label="序列">
        </el-table-column>
        <el-table-column align="center" label="名称">
          <template slot-scope="scope">
            <el-input
              size="normal"
              v-model="scope.row.cpnm03"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="数量">
          <template slot-scope="scope">
            <el-input
              size="normal"
              v-model="scope.row.cpnm04"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column align="center" label="颜色" width="100">
          <template slot-scope="scope">
            <el-color-picker v-model="scope.row.cpnm05"></el-color-picker>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <i
              style="font-size: 18px; color: red;cursor:pointer"
              class="el-icon-remove-outline"
              @click="workList.splice(scope.$index, 1)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column></el-table-column>
        <el-table-column></el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { AddorUpdatecmpnum, Getcmpnumlist } from "@/setAxios";
import dayjs from "dayjs";
export default {
  name: "RunhongXUGK",
  data() {
    return {
      workList: [],
    };
  },
  mounted() {},
  created() {
    this.Getcmpnumlist();
  },
  methods: {
    Getcmpnumlist() {
      let params = {
        xid: this.$store.state.xid,
      };
      Getcmpnumlist({ params }).then((res) => {
        this.workList = res.Data.list;
      });
    },
    async AddOrUpdate(index) {
      let that = this;
      for (let i = 0; i < this.workList.length; i++) {
        const el = this.workList[i];
        el.cpnm02 = that.$store.state.xid;
        if (!el.cpnm05) {
          this.$message({
            message: "请将颜色配置完整！",
            type: "warning",
          });
          return;
        }
      }
      let params = {
        xid: this.$store.state.xid,
        cmpnum: this.workList,
      };
      let res = await AddorUpdatecmpnum(params);
      if (res.Code) {
        this.$message({
          message: "保存成功",
          type: "success",
        });
        //刷新
        this.Getcmpnumlist();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.mar-right {
  margin-right: 30px;
}

.mar-but {
  margin-bottom: 30px;
}

.pua-right {
  margin-right: 15px;
}

.inpt-top {
  padding-top: 10px;
}
</style>
